"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SORTABLE_LOG_REPORTE_CSV_BLOQUEO_COLUMNS_MAP = void 0;
exports.SORTABLE_LOG_REPORTE_CSV_BLOQUEO_COLUMNS_MAP = {
    plataforma: 'log_plataforma',
    responsable: 'log_responsable',
    correctos: 'log_correctos',
    incorrectos: 'log_incorrectos',
    fecha_creacion: 'log_fecha_creacion',
};
